<template>
  <v-menu id="user-menu" v-model="isMenuVisible" eager>
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        class="mx-1 bg-primary"
        width="48px"
        height="48px"
        style="border-radius: 24px !important; min-width: 0"
        elevation=0
        data-cy="topbar-beeUserMenu-button"
      >
        <img v-if="getDarkMode" class="" src="../../../../assets/images/smalltw-dark.png"
             style="width: 30px; height: 30px;" :alt="$t('menus.topBars.toggleAccountMenu')"/>
        <img v-if="!getDarkMode" class="" src="../../../../assets/images/smalltw-light.png"
             style="width: 30px; height: 30px;" :alt="$t('menus.topBars.toggleAccountMenu')"/>
      </v-btn>
    </template>

    <v-list density="compact">
      <v-list-item>
        <div class="d-flex flex-column justify-start user-menu-contact">
          <span>{{ $t('layouts.main.contactHeading') }}</span>
          <span><a href="mailto:support@tubeway.io?subject=TubeWay%20Customer%20Support">support@tubeway.io</a></span>
          <span><a href="tel:+31353033266">+31 (0) 353 033 266</a></span>
        </div>
      </v-list-item>

      <v-divider/>

      <v-list-item class="py-0" data-cy="topbar-beeUserMenu-toggleLightDarkMode">
        <v-switch
          class="px-2"
          v-model="isDarkMode"
          @update:model-value="toggleDarkMode"
          :label="$t('layouts.main.darkMode')"
          color="primary"
          density="compact"
          hide-details
        />
      </v-list-item>

      <v-divider/>

      <v-list-item
        v-if="forceManagementConsole || $vuetify.display.smAndDown"
        to="/console/index"
        data-cy="beeUserMenu-managementConsole"
      >
        {{ $t('layouts.main.managementConsole') }}
      </v-list-item>

      <v-list-item to="/account/logout" data-cy="topbar-beeUserMenu-logout">
        {{ $t('layouts.main.logout') }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { useMainStore } from '@/stores/MainStore.js'
import { usePodStore } from '@/stores/PodStore.js'
import { useAccountStore } from '@/stores/AccountStore.js'

export default {
  name: "BeeUserMenu",
  props: {
    forceManagementConsole: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data: function() {
    return {
      isDarkMode: false,
      isMenuVisible: false,
    };
  },
  mounted: function() {
    setTimeout(() => {
      this.isDarkMode = this.getDarkMode;
    }, 1500);
  },
  methods: {
    toggleDarkMode() {
      const mainStore = useMainStore();
      mainStore.setDarkMode(!this.getDarkMode);

      const accountStore = useAccountStore();
      accountStore.changeTheme({ theme: this.getDarkMode ? 'dark' : 'light' })
        .then(() => {
          console.log('The theme was changed successfully.');
        }).catch((error) => {
          console.error(error);
      });
    },
  },
  computed: {
    getDarkMode() {
      const mainStore = useMainStore();
      return mainStore.getDarkMode;
    },
  },
  watch: {
    isMenuVisible(newVal) {
      if (newVal) {
        const podStore = usePodStore();
        if (podStore.isQuickSwitcherVisible) {
          podStore.toggleQuickSwitcher();
        }
      }
    }
  }
}
</script>

<style scoped>
#user-menu {
  z-index: 100;
}

.user-menu-contact {
  padding-bottom: 0.75rem;
}

.user-menu-contact > span {
  line-height: 2rem;
}
</style>
